import React from "react";
import { observer } from "mobx-react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import Page from "components/Layout/Page";
import PublishButton from "components/PublishButton";

import CategoryCard from "./CategoryCard";

import ROUTES from "navigation/routes";

import { CategoryCardWrapper } from "./styles";

const DEFAULT_CATEGORIES = [
  // { title: "Nutrition", route: ROUTES.IN_APP_TODAY_NUTRITION },
  { title: "Quick Links", route: ROUTES.IN_APP_TODAY_QUICK_LINKS },
  { title: "Day Banners", route: ROUTES.IN_APP_TODAY_BANNERS },
];

type Props = RouteComponentProps & {};

@observer
class Today extends React.Component<Props> {
  openCategoryDetails = (category: any) => () => {
    this.props.history.push(category.route);
  };

  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <Page title="Today">
          {DEFAULT_CATEGORIES.map(category => (
            <CategoryCardWrapper key={category.route}>
              <CategoryCard
                title={category.title}
                onDetailsClick={this.openCategoryDetails(category)}
              />
            </CategoryCardWrapper>
          ))}
        </Page>
      </Container>
    );
  }
}

export default withRouter(Today);
